export default {"src":"/_next/static/media/icon-flag-russia.589f5fa1.svg","height":27,"width":40,"blurWidth":0,"blurHeight":0};